import type { Middleware, UnknownAction } from '@reduxjs/toolkit';
import { ErrorFactory } from './error-factory';
import { NotificationHandler } from './notification-handler';

interface ErrorAction extends UnknownAction {
  /**
   * Payload can be a string (for setError actions) or an error object (for rejected actions)
   */
  payload?: string | null | unknown;
  meta?: {
    code?: string;
  };
  error?: unknown;
}

/**
 * Redux middleware for handling errors across the application
 * Intercepts error actions and displays notifications
 */
export const errorMiddleware: Middleware = () => (next) => (action: unknown) => {
  const typedAction = action as ErrorAction;

  if (typedAction.type?.endsWith('/setError') && typedAction.payload) {
    if (typeof typedAction.payload === 'string') {
      const appError = ErrorFactory.create(typedAction.payload, typedAction.meta?.code);
      NotificationHandler.notify(appError);
    }
    return next(action);
  }

  if (typedAction.type?.endsWith('/rejected')) {
    const errorData = typedAction.payload || typedAction.error;
    if (errorData) {
      const appError = ErrorFactory.fromApiError(errorData);
      NotificationHandler.notify(appError);
    }
  }

  return next(action);
};
